exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._3ONu7VtYLM98FWOZS0Fsvm{border-top:1px solid \"[theme:neutralLight, default:#eaeaea]\"}", ""]);
// Exports
exports.locals = {
	"horizontalContainer": "_3ONu7VtYLM98FWOZS0Fsvm"
};